export default function (data) {
	let isEmpty = false;

	if (data === undefined) {
		isEmpty = true;
	} else if (data && Array.isArray(data) && data.length < 1) {
		isEmpty = true;
	} else if (data && Object.keys(data).length < 1) {
		isEmpty = true;
	} else if (data.size === 0) {
		isEmpty = true;
	} else if (!data) {
		isEmpty = true;
	}

	return isEmpty;
}
